var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    style: {
      enableBackground: "new 0 0 100 125"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.9,56.2L51.6,49L45,42.4L34.2,53.1l6.7,6.7l7.2,0.3l0.3,7.2L55,74l10.8-10.8l-6.7-6.7L51.9,56.2z  M42.6,55.9l-2.8-2.8L45,48l2.8,2.8l0.2,5.3L42.6,55.9z M55,68.3l-2.8-2.8L52,60.2l5.3,0.2l2.8,2.8L55,68.3z M79.5,29.9h-59 c-5.5,0-10,4.5-10,10v36.2c0,5.5,4.5,10,10,10H48v5h-8.4v4h20.8v-4H52v-5h27.5c5.5,0,10-4.5,10-10V39.9 C89.5,34.4,85,29.9,79.5,29.9z M50,78.2c-11.1,0-20.2-9.1-20.2-20.2S38.9,37.9,50,37.9S70.2,47,70.2,58.1S61.1,78.2,50,78.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOs);
export default __webpack_public_path__ + "static/media/os.ba5714e3875cb6e8e0e41522273fe118.svg";
export { ForwardRef as ReactComponent };